// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes,Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import './assets/css/main.css';
import './assets/css/bootstrap.min.css';

function App() {
  return (
    <Router >
      <div className="App">
        {/* <Navbar /> */}
        <Routes >
          <Route path="/" element={<Home />} />
          <Route path="/:id" element={<Home />} />
          
          
        </Routes>
      </div>
    </Router>
  );
}

export default App;
